module.exports = __webpack_public_path__ + "static/img/card_4_2.f4e717a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/es/card_4_2.png
// module id = Qn6K
// module chunks = 0